import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { referralClient } from "@core/clients";
import { DeleteInvitationVariables } from "@core/types";

const useDeleteInvitationMutation = (options?: UseMutationOptions<any, any, DeleteInvitationVariables>) =>
  useMutation(
    ["deleteInvitation"],
    async (variables) => {
      const data = await referralClient.deleteInvitation(variables);
      return data;
    },
    options
  );

export default useDeleteInvitationMutation;